<nav class="sr-only" aria-label="Dashboard tabs">
  <button style="display:none;" [routerLink]="'/dashboard/apps'" type="button">Overview</button>
  <button [routerLink]="'/dashboard/accounts'" type="button">Accounts</button>
  <button [routerLink]="'/dashboard/settings'" type="button">Settings</button>
</nav>
<router-outlet></router-outlet>
